module.exports = __webpack_public_path__ + "224d8ac84323d3bd3bf2c97d6fd0d4cb.jpg";